export default "__VITE_ASSET__CfSwIeZF__"